const TEST_CONSTANTS = {
  test: 'test',
};

const THEME_COLOR = ''; // customize move to config/custom.js
const THEME_COLOR_SECOND = ''; // customize move to config/custom.js
const SITE_INFO = ''; // customize move to config/custom.js

const LocaleDictionary = {
  order_status: {
    unpaid: {tw: '未付款', en: 'Unpaid'},
    pending: {tw: '待處理', en: 'Pending'},
    processing: {tw: '處理中', en: 'Processing'},
    shipped: {tw: '已出貨', en: 'Shipped'},
    canceled: {tw: '已取消', en: 'Canceled'},
    return_applied: {tw: '退貨審核通過', en: 'Return Applied'},
    return_completed: {tw: '已退款', en: 'Return Completed'},
    unknown: {tw: '未知狀態', en: 'Unknown'},
  },
  payment_subtype: {
    credit: {tw: '信用卡付款', en: 'Credit card'},
  },
  payment_status: {
    pending: {
      en: 'Pending',
      tw: '尚未付款',
    },
    waiting: {
      en: 'Waiting',
      tw: '款項確認中',
    },
    success: {
      en: 'Success',
      tw: '付款成功',
    },
    failure: {
      en: 'Failure',
      tw: '付款失敗',
    },
    returned: {
      en: 'Returned',
      tw: '已退款',
    },
    code_generated: {
      en: 'Pay code generated',
      tw: '已取號',
    },
  },
  logistics_type: {
    SELF_PICK: {
      en: 'Self pick',
      tw: '自取',
    },
    HOME: {
      en: 'Delivery Home',
      tw: '宅配',
    },
  },
  logistics_status: {
    pending: {
      tw: '備貨中',
      en: 'Pending',
    },
    center_delivered: {
      tw: '已出貨',
      en: 'Center delivered',
    },
    in_delivery: {
      tw: '運送中',
      en: 'In delivery',
    },
    store_delivered: {
      tw: '到店尚未取貨',
      en: 'Store delivered',
    },
    delivered: {
      tw: '已送達',
      en: 'Delivered',
    },
    error: {
      tw: '發生錯誤',
      en: 'Error',
    },
    exception: {
      tw: '第三方自定義狀態',
      en: 'Exception',
    },
  },
  invoice_type: {
    // 綠界已棄用三連
    B2B: {
      tw: '三聯式發票(開立統一編號)',
      en: 'Triplicate uniform invoice',
    },
    // 一般的 B2C
    B2C: {
      tw: '電子發票',
      en: 'Uniform Invoice',
    },
    B2C_DONATE: {
      tw: '捐贈',
      en: 'Donation',
    },
    B2C_NPC: {
      tw: '自然人憑證條碼',
      en: 'Citizen digital certificate',
    },
    B2C_PHONE_CARRIER: {
      tw: '手機載具',
      en: 'Phone carrier',
    },
    B2C_PROVIDER: {
      tw: '綠界發票載具',
      en: 'ECPay carrier',
    },
  },
  invoice_status: {
    success: {
      tw: '開立成功',
      en: 'Success to issue',
    },
    pending: {
      tw: '等候開立',
      en: 'Pending',
    },
    failure: {
      tw: '開立失敗',
      en: 'Failed to issue.',
    },
  },
};

export {TEST_CONSTANTS, LocaleDictionary};
